import React from 'react';

import { Button, Form, Select, Space } from 'antd';

import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

type Props = {
  name: string;
  addNewText: string;
  renderField: (field: any) => React.ReactNode;
  onClick?: () => void;
  /** when set, the rendered rows are wrapped in a div with this class so the
   *  list can be styled/scrolled independently of the "add" button (which stays
   *  outside the wrapper). Omitted = unchanged: rows render bare. */
  listClassName?: string;
};

const DynamicFormField: React.FC<Props> = props => {
  const { name, renderField, addNewText, onClick, listClassName } = props;

  return (
    <Form.List name={name}>
      {(fields, { add, remove }) => {
        const rows = fields.map(field => (
          <Space key={field.key}>
            {renderField(field)}

            <MinusCircleOutlined onClick={() => remove(field.name)} />
          </Space>
        ));

        return (
          <>
            {listClassName ? (
              <div className={listClassName}>{rows}</div>
            ) : (
              rows
            )}

            <Form.Item>
              <Button
                type="dashed"
                onClick={() => {
                  add();
                  if (onClick !== undefined) {
                    onClick();
                  }
                }}
                block
              >
                <PlusOutlined /> {addNewText}
              </Button>
            </Form.Item>
          </>
        );
      }}
    </Form.List>
  );
};

export default DynamicFormField;
